export default function DetailSkeletonTwoColumn() {
  return (
    <div className="w-full lg:w-10/12 max-w-screen-2xl mx-auto px-5 py-10 flex flex-col lg:flex-row gap-8">
      {/* Sidebar Skeleton */}
      <div className="w-full lg:w-1/4 space-y-4">
        <div className="h-8 w-3/4 bg-gray-200 rounded skeleton" />
        <div className="h-4 w-full bg-gray-200 rounded skeleton" />
        <div className="h-4 w-full bg-gray-200 rounded skeleton" />
        <div className="h-4 w-full bg-gray-200 rounded skeleton" />
      </div>

      {/* Content Skeleton */}
      <div className="flex-1">
        <div className="h-8 w-3/4 bg-white rounded skeleton" />

        <div className="py-4 space-y-4">
          <div className="h-4 w-1/4 bg-gray-200 rounded skeleton" />
          <div className="h-4 w-5/6 bg-gray-200 rounded skeleton" />
          <div className="h-4 w-4/6 bg-gray-200 rounded skeleton" />
        </div>
      </div>
    </div>
  );
}
